export const arrayBufferToBase64 = arrayBuffer => {
    return btoa(String.fromCharCode(...new Uint8Array(arrayBuffer)));
};

export const base64ToArrayBuffer = base64 => {
    return Uint8Array.from(atob(base64), c => c.charCodeAt(0)).buffer;
};
